// type TradeInFeatureConfiguration = {
//   type?: string;
// }
const jsonnetConfigService = {
    // TODO update service
    // getPXIntegrationType(data: any): TradeInIntegrationType {
    //   const tradeInFeatureConfiguration: TradeInFeatureConfiguration = Object.values(
    //     (data as TradeInIntegrationType).partExchange || {}
    //   ).pop();
    //   if (
    //     Object.values(TradeInIntegrationType).includes(
    //       tradeInFeatureConfiguration?.type as TradeInIntegrationType
    //     )
    //   ) {
    //     return tradeInFeatureConfiguration.type as TradeInIntegrationType;
    //   }
    //
    //   return TradeInIntegrationType.NONE;
    // },
    normalizePriceDisplay(data) {
        const priceDisplay = { secondaryOptions: false };
        Object.entries(data).forEach(([, value]) => {
            const priceDisplayOptions = value;
            Object.entries(priceDisplayOptions).forEach(([key, value]) => {
                priceDisplay[key] = value;
            });
        });
        return priceDisplay;
    },
    fromJsonnet(data) {
        const priceDisplay = { secondaryOptions: false };
        Object.entries(data).forEach(([key, value]) => {
            priceDisplay[key] = value;
        });
        return priceDisplay;
    },
    transformFinanceCalculator(financeCalculator) {
        return {
            ...financeCalculator,
            financeApplication: {
                ...financeCalculator.financeApplication,
                availableSteps: financeCalculator.financeApplication.availableSteps?.map((step) => step.slice(step.indexOf('|') + 1)) ?? [],
            },
        };
    },
};
export default jsonnetConfigService;
//# sourceMappingURL=jsonnetConfigService.js.map